import { poiBankRequest } from '../apis/main';
import { fetchfunlidayInit, fetchTwitterInit } from '../apis/init';
import {
  FETCH_INIT_SUCCESS,
  FETCH_INIT_FAIL,
  FETCH_INIT,
  FETCH_POI_BANK_INIT_SUCCESS,
  FETCH_POI_BANK_INIT_FAIL,
  FETCH_POI_BANK_INIT
} from './action_types';
import { TWITTER_LOGIN_INIT } from '../actionTypes/login';
import {
  POI_BANK_NEXT_STATUS_SUCCESS_AUTH_CODE,
  POI_BANK_NEXT_STATUS_SUCCESS_ACCESS_TOKEN
} from '../utilities/constants';
import initAdapter, { writeWebToken } from '../utilities/initAdapter';
// eslint-disable-next-line import/named, prettier/prettier
import { fetchPoiBankInitUrl, fetchPoiBankInitCallBackUrl } from '../utilities/url_util';
// eslint-disable-next-line import/named
import { getClientId, getRandomString } from '../utilities/uuid_util';

const CryptoJS = require('crypto-js');

// init request
export const fetchInit = queryString => {
  const yahooParams = (queryString && queryString.source) || '';

  return dispatch => {
    // dispatch FETCH_INIT for update view state
    dispatch({ type: FETCH_INIT });
    // use data from adaptor 如介接有資料則用之
    const { webToken, initParams } = initAdapter;
    if (webToken && initParams) {
      console.log('call method fetchInit, using initAdapter values');
      writeWebToken(webToken);
      dispatch({
        type: FETCH_INIT_SUCCESS,
        payload: { status: 203, results: initParams }
      });
    } else {
      console.log('call method fetchInit, using api fetch');
      fetchfunlidayInit(yahooParams)
        .then(response => {
          if (response.data.status === '200') {
            const { status, results } = response.data;
            dispatch({
              type: FETCH_INIT_SUCCESS,
              payload: { status, results }
            });
          } else {
            const { status, message } = response.data;
            dispatch({
              type: FETCH_INIT_FAIL,
              payload: { status, errorMessage: message }
            });
          }
        })
        .catch(error => {
          dispatch({
            type: FETCH_INIT_FAIL,
            payload: { status: '404', errorMessage: error.message }
          });
        });
    }
  };
};

export const fetchInitForBot = (webToken, expiredAt) => dispatch => {
  dispatch({ type: FETCH_INIT });
  dispatch({
    type: FETCH_INIT_SUCCESS,
    payload: {
      status: 200,
      results: [
        {
          key: 'Ads',
          os: '2',
          version: '1.0.0',
          _id: '5f0fe56a4d6932d150167e7d',
          value: {
            discover: {
              description: '意外無所不在',
              dynamic: false,
              id: 'discover_002',
              image: {
                '1X': 'https://assets.funliday.com/ads/20200624-tmnewa/discover-a-720x480.jpg',
                '2X': 'https://assets.funliday.com/ads/20200624-tmnewa/discover-a-1440x960.jpg'
              },
              sponsorIcon: {
                '1X': 'https://assets.funliday.com/ads/20200624-tmnewa/avatar-80x80.jpg',
                '2X': 'https://assets.funliday.com/ads/20200624-tmnewa/avatar-80x80.jpg'
              },
              sponsorName: '新安東京海上產險',
              title: '國內旅遊也要投保旅平險，3天200萬保障不到80元！',
              url: 'https://b2c.tmnewa.com.tw/insurance/travel/index'
            },
            placeExplore: {
              description:
                '一張保單就可保，新安東京海上產險享有班機延誤、行李遺失等保障',
              dynamic: false,
              id: 'place_explore_002_tmnewa',
              image: {
                '1X': 'https://assets.funliday.com/ads/20200215-tmnewa/funliday-180x135-B.jpg',
                '2X': 'https://assets.funliday.com/ads/20200215-tmnewa/funliday-360x270-B.jpg'
              },
              title: '親友出國如何一起投保旅遊險？',
              url: 'https://www.tmnewa.com.tw/b2c_v2/contents/travel.html?utm_source=Funliday&utm_medium=bannerB&utm_campaign=together%20insured'
            }
          }
        },
        {
          key: 'WebToken',
          value: {
            expiredAt,
            salt: 0,
            webToken
          }
        },
        { key: 'Target', value: 1 }
      ]
    }
  });
};

// poi bank init request
export const fetchPoiBankInit = () => {
  const url = fetchPoiBankInitUrl();

  return dispatch => {
    // dispatch FETCH_POI_BANK_INIT for update view state
    dispatch({ type: FETCH_POI_BANK_INIT });
    // use data from adaptor 如介接有資料則用之
    const { poibankToken: poiBankToken } = initAdapter;
    if (poiBankToken) {
      console.log('call method fetchPoiBankInit, using initAdapter values');
      dispatch({
        type: FETCH_POI_BANK_INIT_SUCCESS,
        payload: { status: 108, results: poiBankToken }
      });
    }
    // else fallback to prior logic 退回至旧有邏輯處理
    else {
      console.log('call method fetchPoiBankInit, using api fetch');
      const uuid = getClientId();
      const randomKey = getRandomString(16);
      const cipherText = encrypted(randomKey, uuid);
      const codeChallenge = `${cipherText}_1_${randomKey}`;
      poiBankRequest
        .post(url, {
          client_id: uuid,
          code_challenge: codeChallenge
        })
        .then(response => {
          const {
            data: { code, auth_code }
          } = response;
          if (code === POI_BANK_NEXT_STATUS_SUCCESS_AUTH_CODE) {
            return poiBankRequest.post(fetchPoiBankInitCallBackUrl(), {
              code_verifier: uuid,
              auth_code
            });
          }
          dispatch({
            type: FETCH_POI_BANK_INIT_FAIL,
            payload: { status: '404', errorMessage: null }
          });

          return null;
        })
        .then(response => {
          // temporaty not handle response data from poi bank init
          const {
            data: { code }
          } = response;
          if (code === POI_BANK_NEXT_STATUS_SUCCESS_ACCESS_TOKEN) {
            dispatch({
              type: FETCH_POI_BANK_INIT_SUCCESS,
              payload: { status: code, results: response.data }
            });
          }
        })
        .catch(error => {
          dispatch({
            type: FETCH_POI_BANK_INIT_FAIL,
            payload: { status: '404', errorMessage: error }
          });
        });
    }
  };
};

export const fetchPoiBankInitForBot = poiBankToken => dispatch => {
  dispatch({ type: FETCH_POI_BANK_INIT });
  dispatch({
    type: FETCH_POI_BANK_INIT_SUCCESS,
    payload: {
      status: 108,
      results: {
        access_token: poiBankToken,
        code: 108,
        code_message: 'success access_token',
        expired_at: 8012692923
      }
    }
  });
};

export const encrypted = (key, text) => {
  // initial vector string
  const iv = CryptoJS.enc.Utf8.parse('funliday-poibank');
  const cipher = CryptoJS.AES.encrypt(text, CryptoJS.enc.Utf8.parse(key), {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return cipher.toString();
};

export const initTwitterLogin = () => async dispatch => {
  dispatch({ type: TWITTER_LOGIN_INIT.LOADING });

  try {
    const response = await fetchTwitterInit();
    if (response.data.status === '200') {
      dispatch({
        type: TWITTER_LOGIN_INIT.SUCCESS,
        payload: response.data?.results
      });
    } else {
      dispatch({ type: TWITTER_LOGIN_INIT.FAIL });
    }
  } catch (error) {
    dispatch({ type: TWITTER_LOGIN_INIT.FAIL });
  }
};
